import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class DataServiceService {
  constructor(private http: HttpClient) {}

  countryStore = new BehaviorSubject("Nigeria");

  getLocation(): any {
    return this.http.get("https://extreme-ip-lookup.com/json/");
  }
}
